import { IComponentOptions, IScope } from "angular";
import { IAssignee } from "@gtmhub/assignees";
import { INestedTreeOkrNode } from "@gtmhub/okrs/alignment-tree";
import { IdMap } from "@gtmhub/util";

type OkrDropdownAction = "create" | "delete";

interface INestedViewOKRNodeBindings {
  node: INestedTreeOkrNode;
  assigneesMap: IdMap<IAssignee>;
  sameDepthNodes: INestedTreeOkrNode[];
  isParentObfuscated: boolean;
  sessionStatus: string;
  sessionAllowedActions: string[];
  indexPosition: number;
  belongsToLastNode: boolean;
  progressAggregationDisabled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface NestedViewOKRNodeCtrl extends INestedViewOKRNodeBindings {}
export class NestedViewOKRNodeCtrl {
  isObfuscated: boolean;
  isFirstRootGoal: boolean;
  previousNode: INestedTreeOkrNode;
  lastExpandedNode: boolean;
  static $inject = ["$scope"];

  constructor(private $scope: IScope) {}

  $onInit = () => {
    if (this.node.type === "goal") {
      this.isObfuscated = this.node.goal.private && this.node.goal.obfuscated;
    }
    if (this.node.depth == 1 && this.indexPosition == 0) {
      this.isFirstRootGoal = true;
    }
    if (this.indexPosition > 0) {
      this.previousNode = this.sameDepthNodes[this.indexPosition - 1];
    }
    if (this.belongsToLastNode && this.indexPosition == this.sameDepthNodes.length - 1) {
      this.lastExpandedNode = true;
    }
  };

  toggleExpand = () => {
    const { isExpanded, type, goal, metric } = this.node;
    const okrId = type === "goal" ? goal.id : metric.id;
    this.node.isExpanded = !isExpanded;
    this.$scope.$emit("nestedTree.okrExpandToggled", okrId, !isExpanded);
  };

  isActionAllowed = (action: OkrDropdownAction): boolean => {
    return this.sessionAllowedActions.includes(action) && this.sessionStatus === "open";
  };

  confirmDeleteGoal = (goalId: string): void => {
    this.$scope.$emit("nestedTree.confirmDeleteGoal", goalId);
  };

  confirmDeleteMetric = (goalId: string, metricId: string): void => {
    this.$scope.$emit("nestedTree.confirmDeleteMetric", goalId, metricId);
  };

  openCloneMetricModal = (metricId: string): void => {
    this.$scope.$emit("nestedTree.cloneMetric", metricId);
  };

  openCloneGoalModal = (goalId: string): void => {
    this.$scope.$emit("nestedTree.cloneGoal", goalId);
  };

  showTitleTooltip = (id: string) => {
    const element = document.getElementById(id);
    return element.offsetWidth < element.scrollWidth;
  };

  getNodeStyles = () => {
    const isObfuscated = this.node.type === "goal" ? this.isObfuscated : this.isParentObfuscated;
    return {
      highlighted: this.node.filterMatched,
      obfuscated: isObfuscated,
      expanded: this.node.isExpanded && this.node.children.length > 0,
      "previous-expanded": this.previousNode && this.previousNode.isExpanded && this.previousNode.children.length,
      "last-expanded-node": this.lastExpandedNode,
      "is-first-root": this.isFirstRootGoal,
    };
  };
  getNodeName = () => {
    return this.node.type === "metric" ? this.node.metric.name : this.node.goal.name;
  };
}
export const NestedViewOKRNodeComponent: IComponentOptions = {
  templateUrl: require("./nested-view-okr-node.jade"),
  controller: NestedViewOKRNodeCtrl,
  bindings: {
    node: "=",
    assigneesMap: "<",
    sameDepthNodes: "<",
    indexPosition: "<",
    isParentObfuscated: "<",
    sessionStatus: "<",
    sessionAllowedActions: "<",
    belongsToLastNode: "<",
    progressAggregationDisabled: "<",
  },
};
